<span *ngIf="profile" wizHeadTitle>
  {{ profile.firstName ? profile.firstName : '' }}
  {{ profile.lastName ? profile.lastName : '' }}
  - WIZBII
</span>

<span *ngIf="profile" wizHeadDescription>
  {{ profile.firstName ? profile.firstName : '' }}
  {{ profile.lastName ? profile.lastName : '' }}
  <ng-container i18n>a publié son profil professionnel sur WIZBII.</ng-container>
</span>

<profile-identity
  class="profile-identity"
  [profile]="profile"
  [loading]="loading$ | async"
  itemscope
  itemtype="http://schema.org/Person"
></profile-identity>

<profile-resume class="profile-resume" [profile]="profile" [loading]="loading$ | async"></profile-resume>
